// extracted by mini-css-extract-plugin
export default {"root":"PaymentAllocation_root__yMpjG","invoice-type":"PaymentAllocation_invoice-type__75BuE","amount":"PaymentAllocation_amount__mgftF"};